import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { GlgPopup } from '../../../../shared/components'

class PopCheckpointWarningPopup extends Component {
  render() {
    const { show, observationCount, confirmUrl, onConfirm, onCancel } = this.props

    return (
      <GlgPopup
        title={ !window.I18n ? '' : window.I18n.t('rounds.pop_checkpoint_warning.title') }
        show={ show }
        onClose={ onCancel }
        onSave={ () => onConfirm(confirmUrl) }
        saveButtonText={ !window.I18n ? '' : window.I18n.t('rounds.pop_checkpoint_warning.confirm') }
        closeButtonText={ !window.I18n ? '' : window.I18n.t('rounds.pop_checkpoint_warning.cancel') }
        manualClose={ true }
      >
        <p>
          { !window.I18n ? '' : window.I18n.t('rounds.pop_checkpoint_warning.message', { count: observationCount }) }
        </p>
      </GlgPopup>
    )
  }
}

PopCheckpointWarningPopup.propTypes = {
  show: PropTypes.bool,
  observationCount: PropTypes.number,
  confirmUrl: PropTypes.string,
  onConfirm: PropTypes.func,
  onCancel: PropTypes.func,
}

export default PopCheckpointWarningPopup
